<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 10px 0 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}
.pileItem-div {
  font-weight: 600;
//   margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}
.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;
  >div:first-of-type{
          white-space:nowrap;

    width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }
  >div:last-of-type{
    font-size: 14px;
    min-width: 160px;
    text-align: right;
  }
}

</style>

<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">{{pageTitle}}</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <div class="title-div">{{mainTitle}}</div>
                <el-row :gutter="20">
                    <el-col :span="24" class="margin-b-10"> <span  class="pileItem-div">充电订单信息</span> </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">充电订单编号</div>
                        <div >{{ detailForm.orderNo }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">充电桩IMEI编号</div>
                        <div>{{ detailForm.pileCode }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">充电业务归属</div>
                        <div>{{ detailForm.belongTo }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">订单状态</div>
                        <div >{{ detailForm.payStatusName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">用户手机号</div>
                        <div>{{ detailForm.custPhone }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">订单属性</div>
                        <div v-if="detailForm.orderProperty == '01'">正常</div>
                        <div v-else>异常</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">启动方式</div>
                        <div>{{ detailForm.startWayName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">开始时间</div>
                        <div>{{ detailForm.beginTime }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">结束方式</div>
                        <div>{{ detailForm.endWayName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">结束时间</div>
                        <div >{{ detailForm.endTime }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">充电量（kw·h）</div>
                        <div >{{ detailForm.chargeVal }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">充电时长</div>
                        <div>{{ detailForm.chargeMin }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">备注</div>
                        <div>{{ detailForm.remark }}</div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24"> <span  class="pileItem-div">充电桩信息</span> </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">充电桩IMEI编号</div>
                        <div>{{ detailForm.pileCode }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">充电桩显示名称</div>
                        <div>{{ pileEntity.showName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">电流输出类型</div>
                        <div>{{ pileEntity.currentOutType }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">单相桩/三相桩</div>
                        <div>{{ pileEntity.phaseTypeName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">充电速度</div>
                        <div>{{ pileEntity.chargingSpeedName }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">额定电压（V）</div>
                        <div>{{ pileEntity.ratedVoltage }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">额定电流（A）</div>
                        <div>{{ pileEntity.ratedCurrent }}</div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="6"  class="flex">
                        <div class="cust-detail-title">额定功率（KW）</div>
                        <div>{{ pileEntity.ratedPower }}</div>
                    </el-col>
                </el-row>
            <div class="flex-r-end margin-t-20">
                <button class="common-empty-button" @click="back">返 回</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import utils from '../../../../utils/utils';
    import config from '../../../../config/config';
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                editFlag:false,
                pageTitle:'充电桩详情',
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                // 默认值设置
                detailForm: {},
                pileGunNum:'',
                pileEntity:{},
                detailBreadCrumb:[],
                mainTitle:'正常充电订单'
            }
        },
        methods: {
            init() {
                // console.log(this.$route.params);
                if(localStorage.getItem('detail')){
                    this.editFlag = true;
                    this.detailForm = JSON.parse(localStorage.getItem('detail')) 
                    console.log(this.detailForm);
                    this.getPileInfo();
                }
                let name = this.$route.name;
                if(name == 'pileUnusualDetail'){
                    this.mainTitle = '异常充电订单'
                    this.detailBreadCrumb = this.pageConfig.unusualDetailBreadCrumb
                    }else if(name == 'pileDetailTab'){
                    this.mainTitle = '正常充电订单'
                    this.detailBreadCrumb = this.pageConfig.detailBreadCrumb

                }
                    // this.mainTitle = this.$route.query.isNormal? '正常充电订单':'异常充电订单'
            },
            // 获取表单信息
            getPileInfo(){
                let _ = this;
                _.$H.post(_,_.$A.cust.getPileInfo,{pileCode:_.detailForm.pileCode}).then((res)=>{
                     _.pileEntity = res.data.data;
                });
            },
            back(){
                this.$router.go(-1)
            },
        },
        mounted() {
            // this.mainTitle = this.$route.name =='unusualList'? '异常充电订单':'正常充电订单'
            this.init();
        },
    }
</script>